import React, { useState, useEffect } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { useUser, useOrganization } from '@clerk/clerk-react';

const AlwaysShowWarning = () => {
  const { user } = useUser();
  const { organization } = useOrganization();
  const [hasOrganizations, setHasOrganizations] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkUserOrganizations = async () => {
      if (!user) {
        setHasOrganizations(false);
        setIsChecking(false);
        return;
      }

      try {
        const memberships = await user.getOrganizationMemberships();
        const hasOrgs = memberships.data && memberships.data.length > 0;
        setHasOrganizations(hasOrgs);
      } catch (error) {
        console.error('Error checking user organizations:', error);
        setHasOrganizations(false);
      } finally {
        setIsChecking(false);
      }
    };

    checkUserOrganizations();
  }, [user, organization]);

  // Don't show if user has organizations or if we're still checking
  if (isChecking || hasOrganizations || organization) {
    return null;
  }

  // Only show the warning if user truly has no organizations
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-6 mb-6">
      <div className="flex items-start space-x-4">
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
            <FiAlertTriangle className="h-6 w-6 text-yellow-500" />
          </div>
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-blue-800 mb-2">
            Organization Required
          </h3>
          <p className="text-blue-700">
            You need to be part of an organization to access ARMS features. 
            Organizations help teams collaborate, share resources, and manage costs effectively.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AlwaysShowWarning; 